import type { Doctor } from './types';
import type { AvailableSlot, Practice } from '../../services/api/swaggerSchemas';

export type ProviderOption = Doctor & {
  isAcceptingNewPatients: boolean;
  nickname?: string | null;
  tablespace?: string | null;
  /** Matches `practices[].id` from provider search response (may not match API `practice_id` format). */
  practiceId?: string | null;
  /** Resolved when mapping provider search results; prefer this for display so practice shows even when ids differ. */
  practiceRecord?: Practice | null;
  availableSlotsInWindow?: AvailableSlot[];
  firstAvailableSlotOutsideWindow?: AvailableSlot | null;
  standingOrder?: string | null;
  hospitalFollowUpAppointmentType?: string | null;
  isPatientPcp?: boolean;
  /** From provider search API when patient address geocoding is available. */
  distanceFromPatientMiles?: number | null;
};

/** Stable selection key that disambiguates the same provider at different clinics. */
export function providerSelectKey(provider: ProviderOption): string {
  return `${provider.id}|${provider.practiceId ?? ''}`;
}
